import { describeResource } from '@siteless/resource';
import { z } from 'zod';
import { doc, getDoc } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';

let firestoreTimestampSchema = z.object({
  nanoseconds: z.number(),
  seconds: z.number(),
});

let objectiveStateCeremonyDetails = z.object({
  ceremonyStartAt: firestoreTimestampSchema,
  didCeremonyEnd: z.boolean(),
  didCeremonyStart: z.boolean(),
});

function normalizeCeremonyDetails(raw: Record<string, unknown>) {
  const rawCeremonyDetails = raw.ceremonyDetails as Record<string, unknown>;
  const ceremonyStartAt = rawCeremonyDetails?.ceremonyStartAt;

  return {
    ...raw,
    ceremonyStartAt,
  };
}

export let ObjectiveStateCeremonyDetails = describeResource(
  'ObjectiveStateCeremonyDetails',
  {
    get: async () => {
      let rawData = (await getDoc(doc(database, 'objective_state', String(thisOscarsYear)))).data();
      return objectiveStateCeremonyDetails.parse(
        normalizeCeremonyDetails(rawData as Record<string, unknown>),
      );
    },
  },
);
